var _defs, _g;
var _excluded = ["size"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgPhone = function SvgPhone(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "phone_svg__a",
    d: "M0 0h39.669v30.722H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.456 1H8.966C4.842 1 1.467 4.306 1.467 8.345v79.31c0 4.04 3.375 7.345 7.499 7.345h37.49c4.124 0 7.499-3.306 7.499-7.345V8.345c0-4.04-3.375-7.345-7.5-7.345",
    stroke: "#222",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.699 13.011H2.096M54.699 79.856H2.096",
    stroke: "#010101",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.685 86.644c0 1.732-1.472 3.134-3.29 3.134-1.814 0-3.285-1.402-3.285-3.134 0-1.731 1.471-3.133 3.286-3.133 1.817 0 3.289 1.402 3.289 3.133",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.452 22.933)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "phone_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#phone_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.834 0C8.88 0 0 6.482 0 14.479c0 4.177 2.438 7.93 6.313 10.573-.35 1.058-1.723 4.475-5.099 5.45 0 0 5.813 1.388 10.52-2.816 2.475.81 5.21 1.271 8.1 1.271 10.954 0 19.835-6.481 19.835-14.478S30.788 0 19.834 0",
    fill: "#020202",
    mask: "url(#phone_svg__b)"
  })), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Lato-Bold",
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: 0.375,
    fill: "#FFF",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 46.493,
    y: 40
  }, "SMS")))));
};
export default SvgPhone;